import * as THREE from 'three';

/** F-22 minigun round — short golden tracer slug. */
const CORE = 0xffe082;
const GLOW = 0xffc107;
const TIP = 0xfff8e1;

/**
 * Dense yellowish-golden projectile for the twin minigun.
 * Local +Z is tip-forward before orientation.
 */
export function createMinigunBolt(): THREE.Group {
  const bolt = new THREE.Group();
  bolt.name = 'arcade-minigun-bolt';

  const coreMat = new THREE.MeshBasicMaterial({ color: CORE });
  const glowMat = new THREE.MeshBasicMaterial({ color: GLOW });
  const tipMat = new THREE.MeshBasicMaterial({ color: TIP });

  // Shorter, fatter slug than the rail lance
  const shaft = new THREE.Mesh(new THREE.BoxGeometry(0.14, 0.14, 0.85), coreMat);
  bolt.add(shaft);

  const glow = new THREE.Mesh(new THREE.BoxGeometry(0.22, 0.22, 0.65), glowMat);
  glow.position.z = -0.02;
  bolt.add(glow);

  const tip = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.1, 0.2), tipMat);
  tip.position.z = 0.48;
  bolt.add(tip);

  bolt.userData.radius = 0.9;
  bolt.userData.weaponKind = 'minigun';
  return bolt;
}
